import React from 'react';
import { Form, Select } from '@crisellevaldez/speculo-ui';
import { useAllCitiesData } from '../../../../hooks/cities/useCitiesData';

interface CitySelectorProps {
  organizationId: string;
  selectedCities: string[];
  onChange: (cityIds: string[]) => void;
  error?: string;
  onLoadingChange?: (isLoading: boolean) => void;
}

export const CitySelector: React.FC<CitySelectorProps> = ({
  organizationId,
  selectedCities,
  onChange,
  error,
  onLoadingChange,
}) => {
  const { data: cities = [], isLoading } = useAllCitiesData();

  // Handle loading state changes
  React.useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  const options = React.useMemo(
    () =>
      cities.map((city) => ({
        value: city.id,
        label: `${city.name}, ${city.state}`,
      })),
    [cities]
  );

  return (
    <Form.Control>
      <Form.Label>Subscribe Cities</Form.Label>
      <Form.HelperText>Select cities to enable on your website</Form.HelperText>
      <Select
        searchable={true}
        options={options}
        className="h-10"
        value={selectedCities}
        isLoading={isLoading}
        onChange={(value) => {
          if (Array.isArray(value)) {
            onChange(value);
          }
        }}
        placeholder="Select cities"
        multiple={true}
        error={error}
        rows={5}
      />
    </Form.Control>
  );
};
